// Thrid party and librarys
import React, { useState, useEffect, useMemo } from "react";
import { Formik } from "formik";
import * as Yup from 'yup';
import moment from "moment";
import { useLazyQuery, useMutation } from "@apollo/client";
import _ from "lodash";
import { Table, Form, Modal, Spinner, InputGroup, Button } from "react-bootstrap";

// components and constant
import AnimationLoading from "../../../components/Animationloading";
import { LaoAddress } from "../../../const/laoAddress";
import EmptyComponent from "../../../components/EmptyComponent";
import {
  errorSwal,
  successDeleteSwal,
  successSwal
} from "../../../helper/sweetalert";
import { GET_USERS } from "../../../apollo/user/query";
import CustomButton from "../../../components/CustomButton";
import { APP_COLOR, COLOR_RED_500, LINEAR_GRADIENT_BG } from "../../../const";
import {
  CREATE_USER_V2,
  UPDATE_USER_V2,
  ON_OFF_USER_V2,
  DELETE_USER
} from "../../../apollo/user/mutation";
import ComfirmModal from "../../../components/ComfirmModal";
import { MuiIcons, ReactIcons } from "../../../icons";
import { GET_ROLES } from "../../../apollo/rolePermission/query";
import { FaEye, FaEyeSlash } from "react-icons/fa";



export default function User() {
  const [user, setUser] = useState();
  const [usertotal, setTotalUser] = useState();
  const [showConfirm, setShowConfirm] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [isStatusForm, setIsStatusForm] = useState({
    editMode: false,
    isOpen: false,
    data: null
  });
  const [onOff, setOnOff] = useState(false);
  const [Delete, setDelete] = useState("");
  const [searchUser, setSearchUser] = useState();
  const [changePassword, setChangePassword] = useState(false);

  const [roleDatas, setRoleDatas] = useState({
    total: 0,
    data: []
  })
  const [localShop, setLocoShop] = useState()
  const [roleName, setRoleName] = useState('');
  const [roleId, setRoleId] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  // apollo client hooks
  const [LoadUser, { data: GetUserData, loading }] = useLazyQuery(GET_USERS, {
    fetchPolicy: "cache-and-network",
  });
  const [createUserShop, { loading: loadingCreateUser }] = useMutation(CREATE_USER_V2, {
    onCompleted: (data) => {
      if (data?.createUserV2?.status) {
        _filter();
        handleCloseForm()
        successSwal("ເພີ່ມສຳເລັດ");
      } else {
        errorSwal(data?.createUserV2?.msg);
      }
    }, 
    onError: (error) => {
      console.log("Error in create user", error);
      errorSwal("ບັນທຶກຫລົ້ມແຫລວ");
    }
  });
  const [onOffUser, { loading: loadingDelete }] = useMutation(ON_OFF_USER_V2, {
    onCompleted: async (data) => {
      try {
        if (data?.onOffUserV2?.status) {
          successSwal(data?.onOffUserV2?.msg);
          await _filter();
          setShowConfirm(false);
          setOnOff(false);
        } else {
          errorSwal(data?.onOffUserV2?.msg);
        }
      } catch (error) {
        console.log("Error in onOffUser", error);
      }
    },
    onError: (err) => {
      errorSwal(err.message);
    },
  });
  const [deleteUser, { loading: loadingDeleteUser }] = useMutation(DELETE_USER);
  const [updateUser, { loading: loadingUpdate }] = useMutation(UPDATE_USER_V2, {
    onCompleted: (data) => {
      if (data?.updateUserV2?.status) {
        _filter();
        handleCloseForm()
        successSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
      } else {
        errorSwal(data?.updateUserV2?.msg);
      }
    }, 
    onError: (error) => {
      console.log("Error in update user", error);
      errorSwal("ອັບແດບຫລົ້ມແຫລວ");
    }
  });
  const [getRolePermission, { data: rolePermissionData, loading: loadingGetRole }] = useLazyQuery(GET_ROLES, { fetchPolicy: "network-only" });

  // useEffect Hooks
  useEffect(() => {
    if (GetUserData) {
      setUser(GetUserData?.users?.data);
      setTotalUser(GetUserData?.users?.total);
    }
  }, [GetUserData]);

  useEffect(() => {
    _filter();
  }, []);

  useEffect(() => {
    let localData = JSON.parse(localStorage.getItem("SHOP_DATA"))
    if (localData) {
      setLocoShop(localData)
    }
  }, []);

  useEffect(() => {
    _filter();
  }, [searchUser]);

  useEffect(() => {
    if (rolePermissionData) {
      const { total, data } = rolePermissionData?.rolePermissions;
      setRoleDatas({
        total,
        data
      })
    }
  }, [rolePermissionData])

  useEffect(() => {
    fetchRolePermission()
  }, [])

  // create user
  const _createUser = async (values) => {
    try {
      if (loadingCreateUser) return;
      //TODO validate data
      if(_.isEmpty(values?.firstName)){
        errorSwal("ກະລຸນາປ້ອນຊື່ພະນັກງານ...");
        return;
      }
      if(_.isEmpty(values?.lastName)){
        errorSwal("ກະລຸນາປ້ອນນາມສະກຸນ...");
        return;
      }
      if(_.isEmpty(values?.phone)){
        errorSwal("ກະລຸນາປ້ອນເບີໂທ...");
        return;
      }
      if(_.isEmpty(values?.username)){
        errorSwal("ກະລຸນາປ້ອນຊື່ຜູ້ໃຊ້...");
        return;
      }
      if(_.isEmpty(values?.password)){
        errorSwal("ກະລຸນາປ້ອນລະຫັດຜ່ານ...");
        return;
      }
      if(values?.password.length < 6){
        errorSwal("ລະຫັດຜ່ານຕ້ອງຫຼາຍ 6 ຕົວເລກ");
        return;
      }
      if(_.isEmpty(values?.permission)){
        errorSwal("ກະລຸນາເລືອກສິດນຳໃຊ້ລະບົບ...");
        return;
      }
      if(_.isEmpty(values?.staffCode)){
        errorSwal("ກະລຸນາປ້ອນໂຄດພະນັກງານ...");
        return;
      }
      await createUserShop({
        variables: {
          data: {...values, platform: "POS", userType: "CUSTOMER"},
        },
      });

    } catch (err) {
      console.log("Error in create user", err);
      errorSwal("ບັນທຶກຫລົ້ມແຫລວ");
    }
  };

  // update user
  const _updateUser = async (values) => {
    try {
      if (loadingUpdate) return;
      //TODO validate data
      if(_.isEmpty(values?.firstName)){
        errorSwal("ກະລຸນາປ້ອນຊື່ພະນັກງານ...");
        return;
      }
      if(_.isEmpty(values?.lastName)){
        errorSwal("ກະລຸນາປ້ອນນາມສະກຸນ...");
        return;
      }
      if(_.isEmpty(values?.phone)){
        errorSwal("ກະລຸນາປ້ອນເບີໂທ...");
        return;
      }
      if(_.isEmpty(values?.username)){
        errorSwal("ກະລຸນາປ້ອນຊື່ຜູ້ໃຊ້...");
        return;
      }
      if(_.isEmpty(values?.permission)){
        errorSwal("ກະລຸນາເລືອກສິດນຳໃຊ້ລະບົບ...");
        return;
      }
      if(_.isEmpty(values?.staffCode)){
        errorSwal("ກະລຸນາປ້ອນໂຄດພະນັກງານ...");
        return;
      }
      const { password, nickname, ...updatedValues } = values; // Deleted password from values
      let newData = {
        ...updatedValues
      }
      if(changePassword){
        if(password.length < 6){
          errorSwal("ລະຫັດຜ່ານຕ້ອງຫຼາຍ 6 ຕົວເລກ");
          return;
        }
        newData.password = password;
      }
      const res = await updateUser({
        variables: {
          where: {
            id: isStatusForm?.data?.id,
          },
          data: newData,
        },
      });
      if (res?.data?.updateUser) {
        _filter();
        handleCloseForm()
        successDeleteSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
      }
    } catch (err) {
      errorSwal("ອັບແດບຫລົ້ມແຫລວ");
    }
  };

  // query datas
  const _filter = async () => {
    try {
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

      let _where = {
        shop: shopId,
        // isDeleted: false,
      };

      // TODO: check if search text is not empty
      if (!_.isEmpty(searchUser)) {
        _where = {
          ..._where,
          firstName: searchUser,
        };
      }

      // TODO: Get all product
      await LoadUser({
        orderBy: "createdAt_DESC",
        variables: {
          limit: 50,
          where: _where,
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  // fetch data permissions
  const fetchRolePermission = async () => {
    let localData = JSON.parse(localStorage.getItem("SHOP_DATA"))

    try {
      if (loadingGetRole) return;
      await getRolePermission({
        variables: {
          where: {
            shop: localData?.id,
            isDeleted: false
          },
          // skip: null,
          // limit: null
        }
      })


    } catch (error) {

    }
  }

  // handle show modal deleted user
  const handleShowConfirm = (id, username) => {
    setDelete({ username, id });
    setShowConfirm(true);
  };

  // Delete Staff
  const confirmUserStatus = async () => {
    try {
      if (loadingDelete) return;
      await onOffUser({
        variables: {
          where: {
            id: Delete.id,
          },
          data: {
            isDeleted: onOff
          }
        },
      });
    } catch (err) {
      errorSwal("ການລົບຂໍ້ມູນບໍ່ສຳເລັດ !");
    }
  };

  const handleShowDelete = (id, username) => {
    setDelete({ username, id });
    setShowDelete(true);
  };

  const confirmDeleteUser = async () => {
    try {
      if (loadingDeleteUser) return;
      await deleteUser({
        variables: {
          where: {
            id: Delete.id,
          },
        },
      });
      await _filter();
      successDeleteSwal("ລົບສຳເລັດ");
      setShowDelete(false);
    } catch (err) {
      errorSwal("ການລົບຂໍ້ມູນບໍ່ສຳເລັດ !");
    }
  };

  // handle close modal form create or update
  const handleCloseForm = () => {
    setIsStatusForm({
      editMode: false,
      isOpen: false,
      data: null
    })
  }

  // check validate schema fields
  const validationSchema = Yup.object().shape({
    username: Yup.string().required('ກະລຸນາປ້ອນຊື່ຜູ້ໃຊ້'),
    // isEditMode: Yup.boolean().default(false),
    // changePassword: Yup.boolean().default(false),
    password: Yup.string(),
      // .when('isEditMode', {
      //   is: true,
      //   then: (schema) => schema.notRequired(),
      //   otherwise: (schema) => schema.required('ກະລຸນາປ້ອນລະຫັດຜ່ານ')
      // })
      // .when('changePassword', {
      //   is: true,
      //   then: (schema) => schema.required('ກະລຸນາປ້ອນລະຫັດຜ່ານໃໝ່')
      // }),
    // newPassword: Yup.string()
    //   .when('changePassword', {
    //     is: true,
    //     then: (schema) => schema.required('ກະລຸນາຢືນຢັນລະຫັດຜ່ານໃໝ່')
    //   }),
    firstName: Yup.string()
      .required("ຊື່ພະນັກງານກ່ອນ!"),
    lastName: Yup.string()
      .required("ນາມສະກຸນກ່ອນ!"),
    phone: Yup.string()
      .matches(/^(?!020|030)[0-9]{7,8}$/, "ເບີໂທຕ້ອງມີ 7 ຫຼື 8 ຕົວອັກສອນ ແລະ ບໍ່ຄວນເປັນ 020 ຫຼື 030")
      .required("ປ້ອນເບີໂທກ່ອນ!"),
  });

  // select role
  const onSelectRoleOption = (event) => {
    let _roleId = event?.target?.value;
    setRoleId(_roleId)
    // filter role in roleDatas where in roleId 
    let role = roleDatas?.data?.filter(role => role?.id === _roleId);
    if (role) {
      setRoleName(role[0]?.name);
      return;
    }
    setRoleName(event?.target?.value);
  };

  // filter role permission
  const filteredUsers = useMemo(() => _.isEmpty(roleName) ? user : user?.filter(users => users?.permission?.name === roleName), [roleName, user]);


  return (
    <>

      <div style={{ padding: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h3><b>ຂໍ້ມູນພະນັກງານ</b></h3>
          <p>ລາຍຊື່ພະນັກງານທັງໝົດ [ {usertotal} ] ຄົນ </p>
        </div>
        <CustomButton
          title="ເພີ່ມພະນັກງານ"
          width={140}
          background={LINEAR_GRADIENT_BG}
          icon={<ReactIcons.MdAdd style={{ fontSize: 26 }} />}
          borderRadius="5px"
          onClick={() => setIsStatusForm({
            editMode: false,
            isOpen: true,
            data: null
          })}
        />
      </div>
      <div style={{ padding: "0 20px" }}>
        <div
          style={{
            backgroundColor: "#FFFFFF",
            padding: 10,
            // minHeight: "100vh",
          }}
        >

          <div style={{ display: "flex", gap: 5, padding: '10px 0' }}>
            <div style={{ width: "100%", display: 'flex', justifyContent: 'space-between' }}>
              <Form.Select aria-label="Default select example"
                value={roleId}
                onChange={onSelectRoleOption}
                style={{ maxWidth: 140 }}>
                <option value="">ບົດບາດ</option>
                {/* <option value="1">One</option>  */}
                {roleDatas?.data?.map((role, index) => (
                  <option key={index} value={role?.id}>{role?.name}</option>
                ))}
              </Form.Select>
              <InputGroup style={{ maxWidth: 400 }}>
                <InputGroup.Text
                  style={{
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <MuiIcons.SearchIcon sx={{ color: "#6B7280" }} />
                </InputGroup.Text>
                <Form.Control
                  placeholder="ຄົ້ນຫາພະນັກງານ..."
                  aria-describedby="basic-addon2"
                  onChange={(e) => setSearchUser(e.target.value)}
                  value={searchUser}
                  style={{ borderLeft: "none" }}
                />
              </InputGroup>
            </div>

          </div>

          {loading && !GetUserData && <AnimationLoading />}

          {/* table */}
          {user?.length > 0 ? (
            <Table
              responsive
              style={{
                borderCollapse: "collapse",
                width: "100% ",
              }}
            >
              <thead
                style={{
                  background:
                    "#1F3A60",
                  borderRadius: " 8px 8px 0px 0px",
                  color: "#FFFFFF",
                }}
              >
                <tr>
                  <th>#</th>
                  <th>ໂຄດພະນັກງານ</th>
                  <th>ຊື່ ເເລະ ນາມສະກຸນ</th>
                  <th>ຊື່ນຳໃຊ້</th>
                  <th>ເບີໂທ</th>
                  <th>ບ້ານ, ເມືອງ, ແຂວງ</th>
                  <th>ສິດໃຊ້ລະບົບ</th>
                  <th>ວັນທີເດືອນປີ</th>
                  <th>ສະຖານະ</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers?.map((users, index) => (
                  <tr key={index}>
                    <td style={{ paddingTop: "1rem" }}>{index + 1}</td>
                    <td style={{ paddingTop: "1rem" }}>
                      {users?.staffCode ?? "-"} 
                    </td>
                    <td style={{ paddingTop: "1rem" }}>
                      {users?.firstName} {users?.lastName}{" "}
                    </td>
                    <td style={{ paddingTop: "1rem" }}>{users?.username} </td>
                    <td style={{ paddingTop: "1rem" }}>{users?.phone} </td>
                    <td style={{ paddingTop: "1rem" }}>
                      {users?.address?.village ?? "-"},  {users?.address?.district ?? "-"},  {users?.address?.province ?? "-"}
                    </td>
                    <td style={{ paddingTop: "1rem" }}>
                      {/* <Badge pill bg={users?.role === "ADMIN" ? "danger" : "secondary"}>
                        {users?.role === "ADMIN" ? "ຜູ້ບໍລິຫານ" :  users?.permission?.name ?? "-"}
                      </Badge> */}
                      {users?.permission?.name ?? "-"}
                    </td>
                    <td style={{ paddingTop: "1rem" }}>
                      {moment(users?.createdAt).format("DD/MM/YYYY")}
                    </td>
                    <td style={{ paddingTop: "1rem", color: users?.isDeleted ? "#DC2626" : "#6EC207" }}>
                      {users?.isDeleted ? "ປີດ" : "ເປີດ"}
                    </td>
                    <td  >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CustomButton
                          width="auto"
                          borderRadius="8px"
                          textalign="center"
                          border={`1px solid ${APP_COLOR}`}
                          color={APP_COLOR}
                          background="#F7F7F7"
                          icon={
                            <ReactIcons.MdOutlineEdit
                              style={{ color: APP_COLOR, fontSize: "20px" }}
                            />
                          }
                          onClick={() => {
                            setIsStatusForm({
                              editMode: true,
                              isOpen: true,
                              data: users
                            })
                          }}
                        />
                        &ensp;
                        <CustomButton
                          width="auto"
                          borderRadius="8px"
                          textalign="center"
                          border="1px solid #DC2626"
                          color="#DC2626"
                          background="#F7F7F7"
                          icon={
                            <ReactIcons.RiDeleteBin6Line
                              style={{ color: "#D21C1C", fontSize: "20px" }}
                            />
                          }
                          onClick={() => handleShowDelete(users?.id, users?.username)}
                        />
                        &ensp;
                        <div style={{
                          display: 'inline-block',
                          padding: '5px',
                          borderRadius: '50%',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(15, 15, 14, 0.05)';
                          e.currentTarget.style.transform = 'scale(1.1)';
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                          e.currentTarget.style.transform = 'scale(1)';
                        }}>
                          <Form.Check
                            type="switch"
                            id={`user-status-${users?.id}`}
                            checked={!users?.isDeleted}
                            onChange={(e) => {
                              setOnOff(!e.target.checked);
                              handleShowConfirm(users?.id, users?.username);
                            }}
                            style={{
                              transform: "scale(1.3)",
                              marginTop: "10px",
                              cursor: "pointer"
                            }}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
            </Table>
        ) : (
        <div>
          {user?.length <= 0 && (
            <div
              style={{
                fontSize: "24px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                color: "#6B7280",
                fontWeight: "400",
              }}
            >
              <EmptyComponent />
              <p>ຍັງບໍ່ມີພະນັກງານກະລຸນາໄປເພີ່ມພະນັກງານກ່ອນ !!!</p>
            </div>
          )}
        </div>
          )}
      </div>
    </div >
      {/* Confirm Delete */ }

      < ComfirmModal
        showConfirmModal = { showConfirm }
        handleCancel = {() => setShowConfirm(false)}
        handleConfirm = { confirmUserStatus }
        title = "ແຈ້ງເຕືອນ"
        text = {`ທ່ານຕອ້ງການ ( ${!onOff ? "ເປີດ" : "ປີດ"} ) ການນຳໃຊ້` + ` ${Delete?.username}` + ` ນີ້ເເທ້ບໍ່!`}
      />
      
      < ComfirmModal
        showConfirmModal = { showDelete }
        handleCancel = {() => setShowDelete(false)}
        handleConfirm = { confirmDeleteUser }
        loadingConfirm = { loadingDeleteUser }
        title = "ແຈ້ງເຕືອນ"
        text = {`ທ່ານຕອ້ງການລົບຂໍ້ມູນ ${Delete?.username} ນີ້ເເທ້ບໍ່!`}
      />

    {/* form create and update staff */ }
    <Modal size="lg" show={isStatusForm.isOpen} onHide={handleCloseForm} >
      <Modal.Header closeButton>
        <Modal.Title>{isStatusForm.editMode ? "ແກ້ໄຂຂໍ້ມູນພະນັກງານ" : "ເພີ່ມພະນັກງານ"}</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{
          username: isStatusForm?.data?.username ?? "",
          firstName: isStatusForm?.data?.firstName ?? "",
          lastName: isStatusForm?.data?.lastName ?? "",
          permission:  isStatusForm?.data?.permission?.id ?? "",
          role: "STAFF",
          nickname: isStatusForm?.data?.nickname ?? "",
          phone: isStatusForm?.data?.phone ?? "",
          password: "",
          gender: isStatusForm?.data?.gender ?? "MALE",
          staffCode: isStatusForm?.data?.staffCode ?? "",
          address: {
            village: isStatusForm?.data?.address?.village ?? "",
            province: isStatusForm?.data?.address?.province ?? "",
            district: isStatusForm?.data?.address?.district ?? "",
          },
          shop: localShop?.id
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          isStatusForm.editMode ? _updateUser(values) : _createUser(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldTouched,
          setFieldValue,
          setValues,
          resetForm,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              <div className="row mb-2">
                <div className="col-6">
                  <Form.Label style={{ opacity: 0.7 }}>ຊື່ພະນັກງານ<span style={{ color: "red", marginLeft: "5px" }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.firstName}
                    isInvalid={touched?.firstName && !!errors?.firstName}
                    placeholder="....."
                  />
                  <Form.Control.Feedback type="invalid">
                    <small>{errors?.firstName}</small>
                  </Form.Control.Feedback>
                </div>
                <div className="col-6">
                  <Form.Label style={{ opacity: 0.7 }}>ນາມສະກຸນ<span style={{ color: "red", marginLeft: "5px" }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.lastName}
                    isInvalid={touched?.lastName && !!errors?.lastName}
                    placeholder="....."
                  />
                  <Form.Control.Feedback type="invalid">
                    <small>{errors?.lastName}</small>
                  </Form.Control.Feedback>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-6">
                  <Form.Label style={{ opacity: 0.7 }}>ເບີໂທຕິດຕໍ່<span style={{ color: "red", marginLeft: "5px" }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="phone"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.phone}
                    isInvalid={touched?.phone && !!errors?.phone}
                    placeholder="ປອ້ນເບີໂທ..."
                  />
                  <Form.Control.Feedback type="invalid">
                    <small>{errors?.phone}</small>
                  </Form.Control.Feedback>
                </div>
                <div className="col-6">
                  <Form.Label style={{ opacity: 0.7 }}>ເພດ</Form.Label>
                  <Form.Select
                    name="gender"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.gender}
                  >
                    <option value="FEMALE">ຍິງ</option>
                    <option value="MALE">ຊາຍ</option>
                  </Form.Select>
                </div>
              </div>
              <div className="mt-4">
                <p style={{ fontWeight: 'bold', fontSize: 18 }}><ReactIcons.FaMapMarkerAlt style={{ fontSize: 24, marginRight: 3, color: COLOR_RED_500 }} />ທີ່ຢູ່ພະນັກງານ</p>
              </div>
              <div className="row mb-2">
                <div className="col-3">
                  <Form.Label style={{ opacity: 0.7 }}>ເເຂວງ</Form.Label>
                  <Form.Select
                    name="address.province"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.address?.province}
                    className="w-100"
                  >
                    <option value="">--ເລືອກ--</option>
                    {LaoAddress?.map((p, index) => (
                      <option
                        key={"province" + index}
                        value={p?.province_name}
                      >
                        {p?.province_name}
                      </option>
                    ))}
                  </Form.Select>

                </div>
                <div className="col-3" >
                  <Form.Label style={{ opacity: 0.7 }}>ເມືອງ</Form.Label>
                  <Form.Select
                    name="address.district"
                    disabled={!values?.address?.province}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.address?.district}
                    className="w-100"
                  >
                    <option value="">--ເລືອກ--</option>
                    {values?.address?.province &&
                      LaoAddress.filter(
                        (f) => f?.province_name === values?.address?.province
                      )[0]?.district_list?.map((p, index) => (
                        <option key={"district" + index} value={p?.district}>
                          {p?.district}
                        </option>
                      ))}
                  </Form.Select>
                </div>

                <div className="col-6">
                  <Form.Label style={{ opacity: 0.7 }}>ບ້ານປັດຈຸບັນ</Form.Label>
                  <Form.Control
                    type="text"
                    name="address.village"
                    disabled={!values?.address?.district}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.address?.village}
                    placeholder="...."
                  />
                </div>
              </div>

              <div className="mt-4">
                <p style={{ fontWeight: 'bold', fontSize: 18 }}><ReactIcons.FaUserEdit style={{ fontSize: 24, marginRight: 3, color: COLOR_RED_500 }} /> ຂໍ້ມູນນຳໃຊ້ລະບົບ</p>
              </div>

              <div className="row my-4">
                <div className="col-6 mb-4">
                  <Form.Label style={{ opacity: 0.7 }}>ຊື່ນຳໃຊ້<span style={{ color: "red", marginLeft: "5px" }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="username"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.username}
                    isInvalid={touched?.username && !!errors?.username}
                    placeholder="ຊື່ນຳໃຊ້..."
                  />
                  <Form.Control.Feedback type="invalid">
                    <small>{errors?.username}</small>
                  </Form.Control.Feedback>
                </div>
                {isStatusForm?.editMode ? (
                  <div className="col-12 mb-3">
                    <Form.Check
                      type="checkbox"
                      id="changePasswordCheckbox"
                      label="ປ່ຽນລະຫັດຜ່ານ"
                      checked={changePassword}
                      onChange={(e) => {
                        setChangePassword(e.target.checked);
                        if (!e.target.checked) {
                          setFieldValue('password', '');
                        }
                      }}
                    />
                  </div>
                ) : (
                  <div className="col-6 mb-4">
                    <Form.Label style={{ opacity: 0.7 }}>ລະຫັດຜ່ານ<span style={{ color: "red", marginLeft: "5px" }}>*</span></Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        name="password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.password || ''}
                        isInvalid={touched?.password && !!errors?.password}
                        placeholder="*** *** ***"
                      />
                      <Button 
                        variant="outline-secondary" 
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ borderColor: '#ced4da' }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </Button>
                      <Form.Control.Feedback type="invalid">
                        <small>{errors?.password}</small>
                      </Form.Control.Feedback>
                    </InputGroup>
                  </div>
                )}
                {isStatusForm?.editMode && changePassword && (
                  <div className="col-6 mb-4">
                    <Form.Label style={{ opacity: 0.7 }}>ລະຫັດຜ່ານໃໝ່<span style={{ color: "red", marginLeft: "5px" }}>*</span></Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        name="password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.password || ''}
                        isInvalid={touched?.password && !!errors?.password}
                        placeholder="ປ້ອນລະຫັດຜ່ານໃໝ່"
                      />
                      <Button 
                        variant="outline-secondary" 
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ borderColor: '#ced4da' }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </Button>
                      <Form.Control.Feedback type="invalid">
                        <small>{errors?.password}</small>
                      </Form.Control.Feedback>
                    </InputGroup>
                  </div>
                )}

                <div className="col-6">
                  <Form.Label style={{ opacity: 0.7 }}>ສິດນຳໃຊ້ລະບົບ<span style={{ color: "red", marginLeft: "5px" }}>*</span></Form.Label>
                  <Form.Select
                    name="permission"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.permission}
                  >
                    <option value="">--ເລືອກ--</option>
                    {roleDatas?.data?.map((rName, _idx) => (
                      <option key={_idx} value={rName?.id}>{rName?.name}</option>
                    ))}
                  </Form.Select>
                </div>
                <div className="col-6">
                  <Form.Label style={{ opacity: 0.7 }}>ໂຄດພະນັກງານ<span style={{ color: "red", marginLeft: "5px" }}>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="staffCode"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.staffCode}
                    isInvalid={touched?.staffCode && !!errors?.staffCode}
                    placeholder="ຊື່ນຳໃຊ້..."
                  />
                </div>
              </div>

            </Modal.Body>
            <Modal.Footer>
              <Button type="button" variant="light" onClick={handleCloseForm} disabled={loadingCreateUser || loadingUpdate}><ReactIcons.MdCancel /> ຍົກເລີກ</Button>
              <Button type="submit" disabled={loadingCreateUser || loadingUpdate} style={{ background: LINEAR_GRADIENT_BG, border: 'none' }}>
                {(loadingCreateUser || loadingUpdate) ? <Spinner size="sm" /> : <ReactIcons.FaCheck />} &nbsp;
                {isStatusForm?.editMode ? "ຢືນຢັນແກ້ໄຂ" : "ບັນທຶກ"}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal >

    </>
  );
}
